export default "__VITE_ASSET__ff9d4df5__"